import { Box, List, ListItem, ListItemText, Typography, useMediaQuery, useTheme } from "@mui/material";

export const AvisoDePrivacidadLendia = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const font_title = isMobileOrTablet ? 20 : 28;
  const font_text = isMobileOrTablet ? 14 : 18;
  return (
    <>
      <Box mx={isMobileOrTablet ? 4 : 25} my={6}>
        <Typography color={theme?.palette?.primary?.main} textAlign={"center"} fontWeight={700} fontSize={font_title}>
          Aviso de Privacidad Lendia
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={2}
        >
          Este documento constituye el Aviso de Privacidad para los propósitos previstos en la Ley Federal de Protección
          de Datos Personales en Posesión de los Particulares. Este Aviso de Privacidad es aplicable a los datos
          personales recolectados por LENDIT GROUP S.A.P.I.DE C.V. (en adelante, LENDIA), en su carácter de responsable.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          LENDIA se compromete a proteger el derecho a la privacidad de los datos personales de cualquier titular de los
          datos personales (el “Titular”), también conocido como el "derecho a la autodeterminación informativa," el
          cual es garantizado y protegido como un derecho humano en el segundo párrafo del artículo 16 de la
          Constitución Política de los Estados Unidos Mexicanos y en la legislación aplicable.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          LENDIA señala como domicilio Calle Arquímedes 15, Polanco, Polanco V Sección, Miguel Hidalgo, 11560, Ciudad de
          México, CDMX. Correo de contacto: <strong> usuarios@LENDIA.mx</strong>
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Datos que Recopilamos
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para llevar a cabo las Finalidades descritas en este Aviso de Privacidad, se requiere recopilar y tratar las
          siguientes categorías de datos personales para los Titulares:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "Datos de identificación, como nombres, apellidos, domicilio y rol en el negocio",
            "Geolocalización",
            "Datos fiscales, como Clave CIEC – SAT y Registro Federal de Contribuyentes",
            "Datos de contacto, como correo electrónico, teléfono y celular",
            "Datos de ubicación",
            "Datos laborales",
            "Datos financieros y/o patrimoniales",
            "Datos de historial crediticio",
            "Datos sobre exposición política o parentesco/afinidad con personas políticamente expuestas",
            "Datos sobre antecedentes legales",
            "Datos biométricos, como reconocimiento facial mediante imagen, fotografía, videograbación y/o huella dactilar",
            "Cookies",
            "Página web y Redes Sociales del Solicitante",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{
                  color: theme.palette.primary.dark,
                  fontWeight: 400,
                }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          LENDIA también puede procesar datos personales de terceros proporcionados por usted para fines de contacto en
          casos de cobranza y validación de información. Al proporcionar estos datos, usted confirma que ha informado a
          dichos terceros sobre el uso de sus datos y ha obtenido su consentimiento para que LENDIA los maneje de
          acuerdo con esta política.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Los datos recopilados a través de nuestra plataforma pueden incluir:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Cookies:</strong> Configuraciones e identificadores almacenados en su dispositivo.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Rastro Digital:</strong> Información sobre actividad, comportamiento, intereses y datos
                  personales del usuario.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Uso de la Plataforma:</strong> Contenido visualizado, interacciones, actividades realizadas,
                  personas o cuentas con las que interactúa, frecuencia y duración de las sesiones.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Información del dispositivo:</strong> Sistema operativo, versiones de hardware y software,
                  ubicación GPS, zona geográfica, dirección IP, velocidad de conexión.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
              }}
            />
          </ListItem>
        </List>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Tratamiento de Datos Personales Sensibles
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para establecer la relación jurídica con LENDIA, es posible que se traten datos personales sensibles, como los
          datos biométricos, que incluyen huellas dactilares y características faciales, necesarios para la
          identificación y autenticación de su identidad. Estos datos sensibles serán tratados con el más alto nivel de
          protección y confidencialidad, y se requerirá su consentimiento explícito para su tratamiento, a menos que una
          excepción aplicable en la legislación permita lo contrario.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Finalidades del Tratamiento de Datos Personales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          LENDIA utilizará sus datos personales para cumplir con las siguientes finalidades:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Finalidades Primarias:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Registro en la Plataforma:</strong> Incluye la creación de credenciales de acceso y
                  autenticación de usuarios.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Validación de Información:</strong> Verificación de los datos proporcionados por solicitantes
                  o clientes.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Gestión de Solicitudes:</strong> Identificación y registro como solicitante de un servicio o
                  producto, incluyendo la gestión de personas relacionadas.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Verificación de Identidad y Consultas Crediticias:</strong> Incluye la consulta periódica de
                  historial crediticio ante Sociedades de Información Crediticia y la verificación de identidad según
                  nuestros procedimientos, incluyendo validación de teléfono y datos biométricos.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Perfil Crediticio:</strong> Consultas a sistemas de información de Gobierno incluyendo
                  consulta al SAT para obtener la Constancia de Situación Fiscal, Facturación, Opinión de cumplimiento y
                  Declaraciones, IMSS, entre otros.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Evaluación de Solicitudes:</strong> Determinación de la idoneidad del solicitante para la
                  aprobación del servicio o producto solicitado.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Verificaciones Físicas:</strong> Realización de visitas de verificación para corroborar la
                  información proporcionada.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Localización e Investigación:</strong> Actividades para localizar e investigar a través de
                  referencias proporcionadas.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Prevención de Lavado de Dinero y Financiamiento al Terrorismo:</strong> Cumplimiento de las
                  disposiciones legales aplicables en esta materia.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Elaboración de Contratos:</strong> Preparación y formalización del contrato correspondiente en
                  caso de aprobación de la solicitud.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Cumplimiento de obligaciones legales:</strong> Cumplir con las normativas aplicables.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Inteligencia comercial:</strong> Realizar estudios y programas para identificar hábitos de
                  consumo del Titular y mejorar y actualizar los Sitios, las Apps y los Servicios. Estadística y
                  registro histórico.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Envío de notificaciones:</strong> Comunicaciones sobre transacciones realizadas y envío de
                  estados de cuenta y medios de disposición relacionados con los Servicios contratados.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Gestión y procesamiento de Datos Personales:</strong> Administración y análisis de los Datos
                  Personales para la contratación y otorgamiento de los Servicios, así como el análisis para ofrecer
                  mejoras y beneficios en las condiciones de los Servicios contratados.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Atención y seguimiento:</strong> Responder a sus solicitudes, consultas, dudas y quejas sobre
                  nuestros productos y/o Servicios.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Auditorías:</strong> Realización de auditorías internas y/o externas.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Cumplimiento de Términos y Condiciones:</strong> Asegurar el cumplimiento de los términos y
                  condiciones del producto contratado.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>
        </List>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Finalidades Secundarias (Con su consentimiento):
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Información Publicitaria y Promocional:</strong> Envío de información sobre productos y
                  servicios de LENDIA y sus empresas afiliadas.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Estudios de Satisfacción y Calidad:</strong> Realización de encuestas y estudios para evaluar
                  la calidad del servicio.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Generación de Perfiles de Consumo e Intereses:</strong> Análisis de datos para mejorar la
                  oferta de productos y servicios.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Contacto con Socios Comerciales:</strong> Compartir los datos de contacto del Titular con
                  socios comerciales y sus clientes para facilitar el contacto respecto a los productos y/o servicios
                  que el Titular ofrece.
                </>
              }
              primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400 }}
            />
          </ListItem>
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Si no desea que sus datos personales sean utilizados para estas finalidades secundarias, puede revocar su
          consentimiento enviando un correo electrónico a <strong>contacto@lendia.mx</strong>.
          <br />
          <br />
          LENDIA será responsable del tratamiento de los Datos Personales conforme al presente Aviso de Privacidad. Por
          lo anterior, se hace del conocimiento del Titular que, en caso de que un tercero pretenda tratar sus Datos
          Personales para finalidades propias, dicho tercero se constituirá como responsable de los mismos conforme a la
          Ley y estará obligado a proporcionar su propio Aviso de Privacidad, siendo en consecuencia el único
          responsable de dar cumplimiento a las obligaciones que le correspondan como responsable en términos de la Ley.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Transferencia de Datos Personales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para cumplir con las Finalidades establecidas en el presente Aviso de Privacidad y cumplir con sus
          obligaciones derivadas de la relación jurídica con usted, el Titular manifiesta su consentimiento para que
          LENDIA realice transferencias de sus Datos Personales a terceros, ya sean nacionales o extranjeros.
          <br />
          <br />
          Sujeto a lo establecido en el último párrafo de esta Sección, LENDIA le informa al Titular que, con el objeto
          de poder cumplir con sus obligaciones, LENDIA y/o sus encargados han celebrado o celebrarán diversos acuerdos
          comerciales con los terceros a quien transfiera sus Datos Personales. La autorización del Titular otorgada
          conforme a esta Sección faculta a LENDIA y/o a sus encargados a transferir Datos Personales del Titular a
          dichos terceros, en el entendido que dichos terceros están obligados, por virtud del contrato correspondiente,
          a mantener la confidencialidad de los Datos Personales suministrados por LENDIA y/o sus encargados y al
          cumplimiento de la Ley.
          <br />
          <br />
          Asimismo, para cumplir con las Finalidades establecidas en el presente Aviso de Privacidad y cumplir con sus
          obligaciones derivadas de la relación jurídica con usted, LENDIA podrá transferir sus datos personales sin
          necesidad de su consentimiento a:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  Socios comerciales, tecnológicos y/o financieros: Con quienes se tengan celebrados contratos para la
                  comercialización de productos y/o servicios en beneficio del Titular. Empresas afiliadas, subsidiarias
                  y/o controladoras: Que operen bajo políticas de protección de datos similares.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  Autoridades competentes: En los casos previstos por la normatividad aplicable y para cumplir con la
                  misma.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  Aseguradoras: Para la contratación de seguros y la elaboración de dictámenes relacionados con
                  productos o servicios contratados.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>Instituto Nacional Electoral: Para verificar y validar la autenticidad de los datos proporcionados.</>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>Sociedades de Información Crediticia: Para verificar la calidad financiera y económica del titular</>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  Otras instituciones financieras: En caso de cesión, transmisión, transferencia o negociación de
                  derechos de crédito.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En caso de transferencias internacionales de datos, LENDIA se asegurará de que el país receptor o la
          organización internacional proporcione un nivel adecuado de protección de los datos personales o, de no ser
          así, se tomarán medidas adecuadas para proteger su información. Asimismo, LENDIA se asegurará de que cualquier
          tercero a quien se le transfieran Datos Personales observe y cumpla con lo establecido en el presente Aviso de
          Privacidad, así como con las disposiciones aplicables de la Ley.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          No obstante lo dispuesto en esta Sección o en cualquier otra Sección del presente Aviso de Privacidad, el
          Titular reconoce y acepta que LENDIA no requiere de autorización ni confirmación de dicho Titular para
          realizar transferencias de Datos Personales nacionales o internacionales en los casos previstos en el Artículo
          36 de la Ley o en cualquier otro caso de excepción previsto en la misma y cualquier regulación complementaria.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En caso de que el Titular no desee que LENDIA transfiera sus Datos Personales, podrá manifestar su negativa
          mediante correo electrónico dirigido a la siguiente dirección:
          <strong> contacto@lendia.mx</strong>
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Derechos ARCO y Procedimientos para Ejercerlos
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Usted o su representante legal puede ejercer los derechos de acceso, rectificación, cancelación y oposición
          (ARCO), así como revocar su consentimiento para el tratamiento de sus datos personales. Para hacerlo, deberá
          enviar un correo electrónico a nuestro Departamento de Protección de Datos Personales a{" "}
          <strong> usuarios@lendia.mx</strong>.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Dicha solicitud deberá contener por lo menos el nombre del Titular, domicilio completo o cualquier otro medio
          para recibir notificaciones (correo electrónico), documentos que acrediten su identidad o la personalidad e
          identidad de su representante, descripción de los Datos Personales de los que solicitan su acceso,
          rectificación, actualización o cancelación, la descripción del derecho que pretende ejercer y cualquier otro
          elemento o documento que facilite la localización de los Datos Personales.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          LENDIA comunicará su respuesta física o digitalmente al medio para recibir notificaciones indicado por el
          Titular en su solicitud, dentro de un plazo máximo de 20 días naturales siguientes a la fecha en que se reciba
          la solicitud de acceso, rectificación, cancelación u oposición. Si LENDIA confirma que la solicitud del
          Titular es procedente, LENDIA deberá de cumplir con la solicitud dentro de los 15 días naturales siguientes a
          la fecha de su confirmación de la solicitud.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Uso de Cookies y Tecnologías Similares
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Utilizamos herramientas de comunicación electrónica, óptica y otras tecnologías para recopilar Datos
          Personales relacionados con su actividad en nuestros Medios Electrónicos y Servicios. Puede deshabilitar las
          cookies a través de la configuración de su navegador. Para más detalles, consulte la documentación del
          navegador que esté utilizando.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Nuestros Medios Electrónicos pueden contener enlaces a sitios web de terceros, sobre los cuales LENDIA no
          asume ninguna propiedad, obligación o responsabilidad alguna.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Medidas de Seguridad
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para evitar el acceso no autorizado a los Datos Personales del Titular y con el fin de asegurar que la
          información sea utilizada para las Finalidades establecidas en este Aviso de Privacidad, LENDIA ha establecido
          procedimientos físicos, electrónicos y administrativos que limitan el uso o divulgación de los datos
          personales del Titular, permitiendo a LENDIA tratarlos debidamente. Asimismo, los Datos Personales del Titular
          serán tratados exclusivamente por aquellas personas que realicen actividades que requieran del conocimiento de
          dichos datos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Autoridad en Protección de Datos Personales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Si considera que sus derechos han sido vulnerados, puede ponerse en contacto con nuestro Departamento de
          Protección de Datos Personales y/o presentar una queja ante la Secretaría Anticorrupción y Buen Gobierno. Para
          más información, visite: <strong> https://www.gob.mx/buengobierno </strong>
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Cambios y/o Modificaciones en el AVISO DE PRIVACIDAD
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Este AVISO DE PRIVACIDAD puede ser actualizado periódicamente. Las actualizaciones serán publicadas en
          LENDIA.mx, donde encontrará la versión vigente con la fecha de la última actualización. Además, en caso de
          cambios significativos, se notificará a los Titulares de los datos personales mediante el envío de un correo
          electrónico o a través de avisos visibles en nuestras plataformas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_text}
          mt={4}
        >
          Última actualización: 1 de septiembre de 2025
        </Typography>
      </Box>
    </>
  );
};
